/* JapanSolved™ Icon Taste Exception Ledger v2 — user visual-taste memory and purge rules */
(function () {
  'use strict';
  window.JapanSolvedIconTasteExceptionLedger = {
  "version": "2026-07-07.icon-taste-exception-ledger.v2",
  "generatedAt": "2026-07-07T04:30:00Z",
  "source": "User live visual audit + remove icons.zip + morphology doctrine conversation",
  "doctrine": {
    "userTasteBeatsRegistry": true,
    "noIconPreferredOverWrongIcon": true,
    "boxedSlotsRequireFreeFloatingGlyphs": true,
    "preventDoubleFraming": true
  },
  "purgedHandles": [
    "japansolved-icon-discreet-sensitive",
    "japansolved-icon-logistics-representation",
    "japansolved-icon-advisory-intelligence",
    "japansolved-icon-business-market-entry",
    "japansolved-icon-discreet-small",
    "japansolved-icon-execution-support",
    "japansolved-icon-investments-capital",
    "japansolved-icon-case-review",
    "japansolved-icon-submit-request",
    "japansolved-icon-results-small",
    "japansolved-icon-professional-small",
    "japansolved-icon-strategy-alignment",
    "japansolved-icon-property-relocation",
    "japansolved-icon-sourcing-procurement",
    "japansolved-icon-travel-cultural-access",
    "japansolved-icon-tier-discreet",
    "japansolved-icon-tier-private-access",
    "japansolved-icon-tier-standard",
    "icon-4-japansolved-solutions-sourcing-procurement-modular-supply",
    "17a-js-icon-layered-philosophy",
    "17b-js-icon-layered-philosophy",
    "airplane-jet-09"
  ],
  "purgedIds": [
    "JSICON-0001",
    "JSICON-0002",
    "JSICON-0003",
    "JSICON-0004",
    "JSICON-0005",
    "JSICON-0006",
    "JSICON-0007",
    "JSICON-0008",
    "JSICON-0009",
    "JSICON-0010",
    "JSICON-0011",
    "JSICON-0012",
    "JSICON-0013",
    "JSICON-0014",
    "JSICON-0015",
    "JSICON-0016",
    "JSICON-0017",
    "JSICON-0018",
    "JSICON-0022",
    "JSICON-0090",
    "JSICON-0093",
    "JSICON-0144"
  ],
  "forbiddenVisualTokens": [
    "double-icon",
    "compound-cluster",
    "key-for-human-warmth",
    "coin-for-program",
    "yen-for-program",
    "money-for-program",
    "tiny-cube",
    "small-cube",
    "jewelry-cube",
    "double-frame",
    "native-circle-inside-box",
    "native-box-inside-box"
  ],
  "slotExceptions": {
    "human-warmth": {
      "reject": [
        "key",
        "lock",
        "private-access",
        "romance",
        "couple"
      ],
      "prefer": [
        "human-presence",
        "profile",
        "companion",
        "conversation",
        "people"
      ],
      "reason": "User rejected key/private-access symbolism for Human Warmth."
    },
    "premium-program": {
      "reject": [
        "coin",
        "yen",
        "money",
        "database-money",
        "capital-ledger"
      ],
      "prefer": [
        "program-map",
        "clipboard",
        "route",
        "architecture",
        "crown-if-vip"
      ],
      "reason": "User rejected money/coin visual for premium program cards."
    },
    "boxed-card-icons": {
      "rejectMorphology": [
        "circle",
        "circle-risk",
        "rounded-square",
        "badge",
        "seal",
        "coin",
        "brand-lockup"
      ],
      "preferMorphology": [
        "none"
      ],
      "reason": "Boxed UI needs one page-made box only; avoid double framing."
    },
    "bespoke-architecture-cards": {
      "defaultTreatment": "no-icon",
      "reason": "User judged twelve-door architecture card icons noisy."
    }
  },
  "notes": [
    "Purge list removes icons from active registry.",
    "Morphology classifier also suppresses these handles at runtime if an old registry is accidentally still loaded.",
    "Hard overrides may still specify exact handles, but rejected handles remain blocked unless data-jsi-allow-rejected=\"true\" is explicitly set."
  ]
};
})();
